var Apidae_Layout = (function(){
    var self = {};
    var grid = $('.grid');
    var mapContainer = $('#mapContainer');

    /// self.gridIsotope = undefined;
    self.gridScrollBar = undefined;

    self.infiniteScroll = function(){
        //if(loadData === false){
        loadData = true;
        var href = $('.paginationAjax a').attr('href');
        $('.paginationAjax').remove();

        if(!!href) {
            Apidae_Util.ajaxSend('.spinnerPaginate');
            $.get(href, function (data) {
                var jqObj = jQuery(data);
                var items = $(jqObj.find(".grid .grid__item"));
                var newPaginationAjax = $(jqObj.find(".paginationAjax"));

                $('.pagination').append(newPaginationAjax);

                imagesLoaded(items, function () {
                    grid.append(items);
                    ///self.gridIsotope.append(items).isotope('appended', items);
                    //self.loadSlider();
                    ///self.gridIsotope.isotope();

                    // $(".pinned").pin({
                    //     containerSelector: ".main-content",
                    //     minWidth: 940
                    // });

                    $('html, body').animate({ scrollTop: '+=0' }, 500);
                    Apidae_Util.ajaxComplete('.spinnerPaginate');
                    loadData = false;

                    /// self.gridIsotope.isotope('on', 'layoutComplete', function () {
                    ///     // Init Scroll Reveal
                    ///     if (typeof sr === 'undefined') {
                    ///         window.sr = ScrollReveal();
                    ///     }
                    ///     sr.reveal('.single-item', revealOptions);
                    /// });
                });
            });
        }
    };

    // self.loadSlider = function(){
    //     $('.sliders').bxSlider({
    //         slideWidth:0,
    //         minSlides:1,
    //         maxSlides:1,
    //         moveSlides:1,
    //         slideMargin:0,
    //         mode: 'fade',
    //         pager: false,
    //         auto: false,
    //         adaptiveHeight: true,
    //         captions: false
    //     });
    // };

    self.init = function(){

        //self.loadSlider();

        // init Isotope
        // var masonryMode = grid.data("masonry-mode");

        // self.gridIsotope = grid.isotope({
        //     itemSelector: '.grid__item',
        //     layoutMode: masonryMode,
        //     transitionDuration: '0',
        //     masonry: {},
        //     fitRows: {
        //         rowHeight: 420
        //     },
        //     vertical: {
        //         rowHeight: 120
        //     }
        // });

        // $(".pinned").pin({
        //     containerSelector: ".main-content",
        //     minWidth: 940
        // });
            // if (window.matchMedia("(min-width: 1200px)").matches) {
            //     mapContainer.css({width: mapContainer.closest('#theGrid').outerWidth() / 2});
            // } else {
            //     mapContainer.css({width: mapContainer.closest('#theGrid').outerWidth()});
            // }

        //Wrapper grid Custom Scrollbar
        //self.gridScrollBar = gridWrap.mCustomScrollbar({
        //    live: "on",
        //    scrollInertia: 350,
        //    theme:"dark-thin",
        //    mouseWheel:{ preventDefault: true },
        //    callbacks:{
        //        onTotalScrollOffset:350,
        //        onTotalScroll:function(){ infiniteScroll(); }
        //    }
        //});

        Apidae_Layout.Events.init();
    };

    return self;
})();

Apidae_Layout.Events = (function(){
    var self = {};
    var theGrid = $('#theGrid');
    //var gridWrap = $('.grid__wrapper');
    //var gridWrapOffsetTop = gridWrap.offset().top;
    var grid = $('.grid');
    var mapContainer = $('#mapContainer');
    // var searchByMap = $('.TopBar__searchByMap');
    // var layoutModeValue = 'list';

    self.init = function(){

        $('.masonry-mode-button-group').on( 'click', 'button', function() {
            var masonryModeValue = $(this).data('masonry-mode');
            grid.attr('data-masonry-mode', masonryModeValue);
            ///Apidae_Layout.gridIsotope.isotope({ layoutMode: masonryModeValue });
            //Apidae_Layout.gridScrollBar.mCustomScrollbar("scrollTo","top");
        });

        function gridLayout() {
            if (window.matchMedia("(min-width: 1200px)").matches) {
                mapContainer.css({width: mapContainer.closest('#theGrid').outerWidth() / 2});
              } else {
                mapContainer.css({width: mapContainer.closest('#theGrid').outerWidth()});
            }
            Apidae_Map.resize();
            Apidae_Map.setMarkers(true);
        }

        // change layout mode
        $('.layout-mode-button-single').on( 'click', 'button', function() {
            $(this).toggleClass('is-checked');
            var layoutModeValue = $(this).data('layout-mode');
            theGrid.toggleClass(layoutModeValue);
            setTimeout(gridLayout, 300);
        });

        // change is-checked class on buttons
        $('.button-group').each( function( i, buttonGroup ) {
            var $buttonGroup = $( buttonGroup );
            $buttonGroup.on( 'click', 'button', function() {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $(this).addClass('is-checked');
            });
        });


        // infinite scroll
        $(window).scroll(function(){

            if($('.paginationAjax').length){
                var loadData = false;
                var scrollTop = $(window).scrollTop();
                var browserHeight = $(window).height();
                var offset = $('.paginationAjax').offset();

                if(offset!==null && (offset.top - browserHeight <= scrollTop) && (loadData === false) ){
                    Apidae_Layout.infiniteScroll();
                }
            }
        });

    };

    return self;
})();

$(window).on("load", function(){
    Apidae_Layout.init();
});